import { Box, Divider, Typography, useTheme } from '@mui/material';

type SidebarSectionProps = {
  title: string;
  collapsed: boolean;
  children: React.ReactNode;
};

export const SidebarSection = ({
  title,
  collapsed,
  children
}: SidebarSectionProps) => {
  const theme = useTheme();

  // Don't render anything when collapsed
  if (collapsed) {
    return null;
  }

  return (
    <>
      <Divider sx={{ my: 1, borderColor: theme.palette.divider }} />
      <Box
        sx={{
          px: 2,
          py: 1,
          position: 'sticky',
          top: 0,
          backgroundColor: theme.palette.background.paper,
          zIndex: 1
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.secondary,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </>
  );
};
